import React, { useState, useEffect } from 'react';
import styles from './overview.module.css';
import moment from 'moment';
import TopKips from './TopKips';
import PotentialCostCard from './PotentialCostCard';
import Filter_MS_Overview from './Filter_MS_Overview';
import Tooltip from './Tooltip';
import Filter from './Filter';
import useExcelDownload from '../MileageAnalysisTab_ace/useExelDownload';
import { Download } from 'lucide-react';
import { useCsvBlob } from '../MileageAnalysisTab_ace/useExelDownload';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import DownloadModal from './DownloadModal';

function Overview() {

    const downloadExcel = useExcelDownload();
    const getExcel = useCsvBlob();

    const { isLoading, error, sendReq2: fetchData } = useHttp();

    const [selectedMonth, setSelectedMonth] = useState(moment());
    const [GraphData, setGraphData] = useState({
        overviewCountSummary: {},
        potentialDetailsSummary: {},
        monthWisePerformanceSummary: [],
    });

    function downloadHandler(downloadVia) {
        const { overviewCountSummary, potentialDetailsSummary, monthWisePerformanceSummary } = GraphData;

        if (!monthWisePerformanceSummary?.length) return;

        const overViewData = [{
            "Avg Per Vehicle": overviewCountSummary?.avgPerVehicle,
            "High Per Vehicle": overviewCountSummary?.highPerVehicle,
            "Low Per Vehicle": overviewCountSummary?.lowPerVehicle,
            "Offline Vehicle": overviewCountSummary?.offlineVehicle,
        }];

        const potentialDetailsSummaryData = [{
            "Actual Energy Efficiency": potentialDetailsSummary?.actualEnergyEfficiency,
            "Target Energy Efficiency": potentialDetailsSummary?.targetEnergyEfficiency,
            "Potential Cost Saving": potentialDetailsSummary?.potentialCostSaving,
        }];

        const monthWisePerformanceSummaryData = monthWisePerformanceSummary?.map(item => ({
            "Vin No": item?.key?.vehicleId,
            "Reg. No": item?.key?.vehicle_registration_number,
            "Performance": item?.performance?.toFixed(2) + " %",
            "Distance": item?.Distance?.value + " Kms",
            "Energy Consumed": item?.Energy_Consumption?.value?.toFixed(2) + " KWh",
            "Energy Efficiency": item?.Energy_Efficiency?.value?.toFixed(2) + " KWh/Km",
        }));

        if (downloadVia === "download" && monthWisePerformanceSummary?.length <= 20) {
            downloadExcel(overViewData, "Overview Count Summary");
            downloadExcel(potentialDetailsSummaryData, "Potential Details Summary");
            downloadExcel(monthWisePerformanceSummaryData, "Month Wise Performance Summary");
        }

        if (downloadVia === "email") {
            const formData = new FormData();
            let OverviewCountCSV = getExcel(overViewData, "Overview Count Summary");
            let potentialDetailsSummaryDataCSV = getExcel(potentialDetailsSummaryData, "Potential Details Summary");
            let monthWisePerformanceSummaryCSV = getExcel(monthWisePerformanceSummaryData, "Month Wise Performance Summary");

            formData.append("files", OverviewCountCSV?.file);
            formData.append("files", potentialDetailsSummaryDataCSV?.file);
            formData.append("files", monthWisePerformanceSummaryCSV?.file);

            fetchData({
                url: API_URL_MAIN + `email/send-gmail`, body: formData
            }, () => alert("Email sent Successfully"));

            // alert("Disclaimer: You have selected more than 20 vehicles. The report will be shared via email only.")
            return;
        }
    }

    const [filterData, setFilterData] = useState({
        ...getDateRange(moment()),
        CITY: [],
        DEPO: []
    });

    function getDateRange(monthMoment) {
        return {
            startDate: monthMoment.clone().startOf('month').format('YYYY-MM-DD'),
            endDate: monthMoment.clone().endOf('month').format('YYYY-MM-DD'),
        };
    }

    const goToPreviousMonth = () => {
        const prevMonth = selectedMonth.clone().subtract(1, 'month');
        setSelectedMonth(prevMonth);
        setFilterData(prev => ({
            ...prev,
            ...getDateRange(prevMonth)
        }));
    };

    const goToNextMonth = () => {
        const nextMonth = selectedMonth.clone().add(1, 'month');
        setSelectedMonth(nextMonth);
        setFilterData(prev => ({
            ...prev,
            ...getDateRange(nextMonth)
        }));
    };

    return (
        <div>
            {/* <div className="row mb-3">
                <div className="filter-tab-strip d-flex flex-wrap align-items-center justify-content-start mb-1">
                    <Filter gloablfilter={filterData} onsubmit={setFilterData} />
                </div>
            </div> */}
            <div>

                {/* Top row: Months filter left, Disclaimer + Download right */}
                <div className="row mb-3 align-items-center">
                    {/* Left: Months filter */}
                    <div className="col-md-4 d-flex align-items-center mb-2 mb-md-0">
                        {/* <span className="me-2 fw-medium">Month:</span> */}
                        <span
                            onClick={goToPreviousMonth}
                            className={`${styles.month} me-2`}
                            style={{ cursor: 'pointer' }}
                        >
                            <i className="fas fa-chevron-left"></i>
                        </span>
                        <div className="border p-2 rounded">{selectedMonth.format('MMMM YYYY')}</div>
                        <span
                            onClick={goToNextMonth}
                            className={`${styles.month} ms-2`}
                            style={{ cursor: 'pointer' }}
                        >
                            <i className="fas fa-chevron-right"></i>
                        </span>
                    </div>

                    {/* Right: Disclaimer + Download */}
                    <div className="col-md-8 d-flex justify-content-end align-items-center flex-wrap gap-2">
                        {/* Disclaimer left of Download */}
                        <div className="text-muted small me-3">
                            Disclaimer: Download reports are available for up to 20 vehicles only. Reports for more than 20 vehicles will be sent via email.
                        </div>

                        {/* Download button */}
                        <button
                            data-toggle="modal"
                            data-target={"#Download_MSAce_Overview"}
                            className={`d-flex align-items-center gap-2  ${styles.download_button}` }
                            // style={{
                            //     // // backgroundColor: "#358696",
                            //     // // borderColor: "#358696",
                            //     //  backgroundColor: "transparent",
                            //     // color: "#358696",
                            //     // // cursor: "pointer",
                                  
                            // }}
                            // onMouseEnter={(e) => {
                            //     const el = e.currentTarget;
                            //     el.style.backgroundColor = "black";
                            //     el.style.borderColor = "black";
                                  
                            // }}
                            // onMouseLeave={(e) => {
                            //     const el = e.currentTarget;
                            //     el.style.backgroundColor = "#358696";
                            //     el.style.borderColor = "#358696";
                               
                            // }}
                        >
                            <Download size={20} />
                            <span>Download Report</span>
                        </button>
                    </div>
                </div>

                <TopKips filterData={filterData} setGraphData={setGraphData} />
                <div className="card p-3" style={{ boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
                    <div className="row">
                        <div className="col-12">
                            <PotentialCostCard filterData={filterData} setGraphData={setGraphData} />
                            <Filter_MS_Overview filterData={filterData} setGraphData={setGraphData} />
                        </div>
                    </div>
                </div>
            </div>
            <DownloadModal downloadFunction={downloadHandler} VehicleDataLength={GraphData?.monthWisePerformanceSummary?.length} />
        </div>
    );
}

export default Overview;
